import type { GetAttendanceLogResponse } from "@/openapi/generated";

export function numericIdFromApi(value: unknown): number | null {
  const id = Number(value);
  return Number.isFinite(id) && id > 0 ? id : null;
}

export function attendanceLogClassId(
  log: GetAttendanceLogResponse,
): number | null {
  if (log.classId == null) return null;
  return numericIdFromApi(log.classId);
}

export function attendanceLogStudentId(
  log: GetAttendanceLogResponse,
): number | null {
  return numericIdFromApi(log.studentId);
}

export function attendanceLogAppointmentId(
  log: GetAttendanceLogResponse,
): number | null {
  if (log.appointmentId == null) return null;
  return numericIdFromApi(log.appointmentId);
}
